import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/services/apiClient";
import { useAuth } from "@/context/AuthContext";

const BrandingContext = createContext({ brand: "Meridian" });

export const BrandingProvider = ({ children }) => {
  const { user } = useAuth();
  const [brand, setBrand] = useState("Meridian");

  useEffect(() => {
    if (!user) return;
    api.get("/branding/me")
      .then(({ data }) => setBrand(data.name || "Meridian"))
      .catch(() => setBrand("Meridian"));
  }, [user]);

  const value = useMemo(() => ({ brand }), [brand]);

  return <BrandingContext.Provider value={value}>{children}</BrandingContext.Provider>;
};

export const useBranding = () => useContext(BrandingContext);
